real.button = {

    loading : function(btn, parent) {
        // Put button in loading state.
        btn.prop('disabled', true).addClass('disabled loading');

        // Swap the first visible icon for a spinner and remember the original markup so reset() can put it back.
        // The injected markup mirrors the spinner in howspace/users.js. Font Awesome renders it into an <svg>.
        let icon = btn.find('.icon:visible').first();
        if (icon.length === 0) {
            icon = btn.find('.icon').first();
        }
        if (icon.length && btn.data('spinner-original') === undefined) {
            btn.data('spinner-original', icon[0].outerHTML);
            icon.replaceWith(
                '<i class="icon rotate spinner-third real-btn-spinner" aria-hidden="true">' +
                '<i class="fa-light fa-spinner-third"></i></i>'
            );
        }

        if(!parent) {
            return;
        }

        // Disable all buttons and inputs from parent.
        real.dom.disable(parent);
    },

    reset : function(btn, parent) {
        // Reset button loading state.
        btn.prop('disabled', false).removeClass('disabled loading');

        // Restore the icon that loading() swapped out for the spinner.
        const original = btn.data('spinner-original');
        if (original !== undefined) {
            btn.find('.real-btn-spinner').first().replaceWith(original);
            btn.removeData('spinner-original');
        }

        if(!parent) {
            return;
        }

        // Reset all buttons and inputs from parent.
        real.dom.enable(parent);
    },

    isLoading : function(btn) {
        return btn.is('.disabled.loading');
    }

};
